import React from 'react'
import { DefaultPlayerCon } from '../../styles'

type DefaultPlayerItemParams = {
  position: string
}

export const DefaultPlayerItem: React.FC<
  React.PropsWithChildren<DefaultPlayerItemParams>
> = ({ position }) => {
  return (
    <DefaultPlayerCon>
      <div className="profileCon">
        <div className="profile">
          <div className="pos">{position}</div>
        </div>
      </div>
      <div className="defaultName"></div>
    </DefaultPlayerCon>
  )
}
